<template>
  <div>
      ConsultProtocol
  </div>
</template>

<script>
  export default {
    name: 'ConsultProtocol',
    components: {
    },
    data() {
      return {
      }
    },
    props: {
    },
    methods: {
    },
  }
</script>
